module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/cleaning-mobile-773e20f3707104f61633aadd3958d134.jpg";